import { render, staticRenderFns } from "./SofortDeposit.vue?vue&type=template&id=60f982f6"
import script from "./SofortDeposit.vue?vue&type=script&lang=js"
export * from "./SofortDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports